import moment from "moment";

const convertDate = (date?: string, format = "DD MMMM YYYY") =>
  moment(moment.utc(date).local()).format(format);

export default convertDate;
